import React from 'react';
const LinkTemplateRegExp = new RegExp('<link>.*</link>');
class I18n {
	constructor(dictionary = {}) {
		this.templatePattern = /\{\S+\}/g;
		this.dictionary = dictionary;
	}

	formatMessage(options, values) {
		return this.template(this.dictionary[options.id], values);
	}

	_unsafe_getString(id) {
		return this.dictionary[id] || '';
	}

	template(str, params) {
		if (process.env.NODE_ENV !== 'production' && typeof str !== 'string') {
			console.warn('non-string value passed to stringUtils.template function: ', str); // tslint:disable-line:no-console
			return '';
		}

		if (!str) {
			console.warn('null message id passed: ', str, params); // eslint-disable-line no-console
			return '';
		}
		const splitString = str.split(this.templatePattern) || [];
		const templates = str.match(this.templatePattern) || [];

		return splitString.reduce((final, string, idx) => {
			if (idx === 0) {
				return `${final}${string}`;
			}

			const param = templates[idx - 1] ? templates[idx - 1].replace(/{(\S+)}/, '$1') : '';

			if (params && params.hasOwnProperty(param)) {
				return `${final}${params[param]}${string}`;
			} else {
				return `${final}${string}`;
			}
		}, '');
	}
}

const i18n = new I18n(window.__languageBundle__);

export class FormattedMessage extends React.Component {
	render() {
		const { id, values, ...args } = this.props;
		return (
			<span {...args} data-test-id={id}>
				{i18n.template(i18n.dictionary[id], values)}
			</span>
		);
	}
}
export function FormattedMessageWithLink(props) {
	const { id, values, onClick, ...args } = props;
	const string = i18n.template(i18n.dictionary[id], values);
	const matchData = string.match(LinkTemplateRegExp);
	const isTemplateValid = matchData && matchData.length == 1 && matchData[0].length > 13;
	if (!isTemplateValid) {
		return (
			<span {...args} data-test-id={id}>
				{string}
			</span>
		);
	}
	const linkTextStart = matchData.index;
	const linkTextEnd = linkTextStart + matchData[0].length;

	const textBeforeLink = string.substring(0, linkTextStart);
	const textAfterLink = string.substring(linkTextEnd, string.length);

	const linkText = string.substring(linkTextStart + 6, linkTextEnd - 7);

	return (
		<span {...args} data-test-id={id}>
			<span>{textBeforeLink}</span> <a onClick={onClick}>{linkText}</a> <span>{textAfterLink}</span>
		</span>
	);
}

export const formatMessage = i18n.formatMessage.bind(i18n);
export const formatMessageByString = i18n.template.bind(i18n);
export const _unsafe_getString = i18n._unsafe_getString.bind(i18n);
